import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$sce'];

class ThreatsLandscape {

    constructor($scope, $sce) {

        const availableLanguages = ['en', 'de', 'fr', 'es', 'it', 'ru', 'pt-br'];
        const currentLanguage = CWCONFIG.language;
        let iframeLanguage;
        const isAvailableForCurrentLang = availableLanguages.find(lang => lang === currentLanguage);

        if (isAvailableForCurrentLang) {

            iframeLanguage = isAvailableForCurrentLang;

        } else {

            iframeLanguage = 'en';

        }

        $scope.iframeUrl = $sce.trustAsResourceUrl(`https://www.avira.com/${iframeLanguage}/threat-landscape?source=cw`);

        setTimeout(() => {

            angular.element('.click-area-lightbox').addClass('threats-landscape-wrapper');

        }, 0);

        Mixpanel.send('ConnectWeb News Open', {
            Tab: 'Threats Landscape',
        });

    }

}

_serviceDependencies.push(ThreatsLandscape);

angular.module('controllers')
    .controller('ThreatsLandscape', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/threats-landscape/threats-landscape.js